<template>
	<div class="prizes-carousel-block">
		<div v-if="loadingData" class="spinner">
			<loader />
		</div>

		<div v-if="!loadingData">
			<div class="default-block-title">
				{{ t.mainRewardsBlockTitle }}
			</div>
			<div class="default-block-text">
				{{ t.mainRewardsBlockSubtitle }}
			</div>
		</div>

		<swiper-container
			v-if="!loadingData"
			loop="true"
			slides-per-view="1"
			autoplay-delay="3000"
			pagination-clickable="true"
			style="aspect-ratio: 600/396;"
		>
			<swiper-slide v-for="item in items" :key="item.id">
				<router-link v-slot="{ navigate }" :to="{name: 'prizes-category-prize', params: { prizeId: item.id}, query: {categoryId: item.category_id}}" custom>
					<div class="h-100" @click="navigate">
						<img :src="'/image/i.'+item.image_id+'/w.600:h.400:f.0/image.png'" class="h-100 w-100" style="object-fit: contain;">

						<div v-if="item.items_left > 0" class="prize-tag-limit">
							{{ insertText(t.rewardsLeft, item.items_left) }}
						</div>

						<div v-if="item.prize_tags && item.prize_tags.indexOf('new') >= 0" class="prize-tag-new">
							{{ t.rewardsTagNew }}
						</div>

						<div class="slide-image-background">
							<div class="slide-title">
								<div class="name">
									{{ getTranslation(item.prize_name) }}
								</div>

								<div class="cost">
									{{ formatPrizeCost(item.value) }}
								</div>
							</div>
						</div>
					</div>
				</router-link>
			</swiper-slide>
		</swiper-container>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, inject } from "vue";
import { getTranslation } from "../../includes/helpers"
import { formatPrizeCost, insertText } from '../../includes/helpers'
import { useStore } from '@/js/stores/index';

const axios = inject('axios')
const store = useStore()

// Reactives
const items = ref([])
const loadingData = ref(true)

// Computeds
const t = computed(() => store.translations)

// Methods
async function loadItems(){
	loadingData.value = true

	const response = await axios.get('/api/user-side/getPrizesSuggestionForUser?limit=6')
	items.value = response.data.list
	loadingData.value = false
}

// Lifecycle
onMounted(() => {
	loadItems()
})
</script>
